/* 🤖 this file was generated by svg-to-ts */
export const emperorIconUserShield1: {
  name: 'user_shield_1';
  data: string;
} = {
  name: 'user_shield_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M8.251 16c0-2.301 1.44-3.75 3.75-3.75v0c2.301 0 3.75 1.44 3.75 3.75h-7.5Z"/><path d="M12 6a2.5 2.5 0 1 0 0 5 2.5 2.5 0 1 0 0-5Z"/><path d="M12.001 23C2.11 23 2 6.69 2 6c0-.37.19-.7.51-.88l9-5c.3-.17.66-.17.97 0l9 5c.31.17.51.51.51.87 0 .69-.12 17-10 17ZM4.01 6.58c.1 2.76.98 14.42 7.984 14.42 6.99 0 7.87-11.658 7.984-14.42l-7.984-4.437L4.01 6.58Z"/></g></svg>`
};
